module.exports = __webpack_public_path__ + "img/shoesmith.7584a0df.png";